import { DocumenttypeDisplayModel } from "@/api/model-index";
import { AnfrageService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class GetAnfrageReportDocumenttypesResolver implements Resolve<DocumenttypeDisplayModel[] | null | undefined> {
    constructor(protected anfrageService: AnfrageService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService){}
  
    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DocumenttypeDisplayModel[] | null | undefined> {
      let id: string = <string>route.params['id'];
      let sectionId: string = <string>route.params['abschnittid'];
      let reportId: string = <string>route.params['reportid'];
  
      await this.unfinishedHttpMethodsService.waitByUrl(state.url);

      if(this.portalContextService.CurrentAnfrage && this.portalContextService.CurrentAnfrage.id == id && this.portalContextService.CurrentAnfrage.documenttypes && reportId == this.portalContextService.PreviousBericht?.projektberichtId)
        return of(this.portalContextService.CurrentAnfrage.documenttypes.filter(dokumenttyp => dokumenttyp.sectionId == sectionId)).toPromise();
  
      return this.anfrageService.apiAnfrageAnfrageIdDocumenttypesGet({ anfrageId: id, sectionId: sectionId, byPhase: true, berichtId : reportId}).pipe(map((response: DocumenttypeDisplayModel[]) => {
        if (response) {
          if(this.portalContextService.CurrentAnfrage?.id == id && response != this.portalContextService.CurrentAnfrage?.documenttypes)
            this.portalContextService.CurrentAnfrage.documenttypes = response;
  
          if(this.portalContextService.CurrentAnfrage?.documenttypes)
            return this.portalContextService.CurrentAnfrage.documenttypes.filter(dokumenttyp => dokumenttyp.sectionId == sectionId);
        }
  
        return undefined;
      })).toPromise();
    }
  }
